import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root'
})
export class PreviousRouteService {

  private previousUrl: string;
  private currentUrl: string;

  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        // Send page view event to Google Tag Manager
        this.gtmService.pushTag({
          event: 'page',
          pageName: event.url
        });
      }
    });
  }

  getPreviousUrl() {
    return this.previousUrl;
  }
}
